export default __webpack_public_path__ + "static/media/design-inactive.e78b781b.svg";